"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
/**
 * @internal
 * PendingFormatStatePlugin handles pending format state management
 */
var PendingFormatStatePlugin = /** @class */ (function () {
    /**
     * Construct a new instance of PendingFormatStatePlugin
     * @param options The editor options
     * @param contentDiv The editor content DIV
     */
    function PendingFormatStatePlugin() {
        this.state = {
            pendableFormatPosition: null,
            pendableFormatState: null,
        };
    }
    /**
     * Get a friendly name of  this plugin
     */
    PendingFormatStatePlugin.prototype.getName = function () {
        return 'PendingFormatState';
    };
    /**
     * Initialize this plugin. This should only be called from Editor
     * @param editor Editor instance
     */
    PendingFormatStatePlugin.prototype.initialize = function (editor) {
        this.editor = editor;
    };
    /**
     * Dispose this plugin
     */
    PendingFormatStatePlugin.prototype.dispose = function () {
        this.editor = null;
        this.clear();
    };
    /**
     * Get plugin state object
     */
    PendingFormatStatePlugin.prototype.getState = function () {
        return this.state;
    };
    /**
     * Handle events triggered from editor
     * @param event PluginEvent object
     */
    PendingFormatStatePlugin.prototype.onPluginEvent = function (event) {
        switch (event.eventType) {
            case 13 /* PendingFormatStateChanged */:
                // Got PendingFormatStateChanged event, cache current position and pending format
                this.state.pendableFormatPosition = this.getCurrentPosition();
                this.state.pendableFormatState = event.formatState;
                break;
            case 0 /* KeyDown */:
            case 5 /* MouseDown */:
            case 7 /* ContentChanged */:
                // If content or position is changed (by keyboard, mouse, or code),
                // check if current position is still the same with the cached one (if exist),
                // and clear cached format if position is changed since it is out-of-date now
                if (this.state.pendableFormatPosition &&
                    !this.state.pendableFormatPosition.equalTo(this.getCurrentPosition())) {
                    this.clear();
                }
                break;
        }
    };
    PendingFormatStatePlugin.prototype.clear = function () {
        this.state.pendableFormatPosition = null;
        this.state.pendableFormatState = null;
    };
    PendingFormatStatePlugin.prototype.getCurrentPosition = function () {
        var range = this.editor.getSelectionRange();
        return range && roosterjs_editor_dom_1.Position.getStart(range).normalize();
    };
    return PendingFormatStatePlugin;
}());
exports.default = PendingFormatStatePlugin;
//# sourceMappingURL=PendingFormatStatePlugin.js.map